import BaseService from "../base";
import {
  GetMultipleDelegateToListPayloadType,
  GetMultipleDelegateToListResponseType,
  MultipleDelegatePayloadType,
  MultipleDelegateResponseType,
} from "./types";

class ToDoListService extends BaseService {
  getAccountAbbrList = (success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getToDoListAccountAbbreviations", {}, success, error, returnPara);
  };

  getAllAccountAbbreviations = (para: any, success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getAllAccountAbbreviations", para, success, error, returnPara);
  };

  getActionRequiredDDL = (success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getActionRequiredDDL", {}, success, error, returnPara);
  };

  getActionTakenDDL = (success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getActionTakenDDL", {}, success, error, returnPara);
  };

  getProcessCategoryDDL = (success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getProcessCategoryDDL", {}, success, error, returnPara);
  };

  getPendingList = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getPendingList", para, success, error);
  };

  getPendingListFilter = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getPendingListFilter", para, success, error);
  };

  getCompletedList = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getCompletedList", para, success, error);
  };

  getCompletedListFilter = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getCompletedListFilter", para, success, error);
  };

  submitDelegate = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("submitDelegate", para, success, error);
  };

  delegateCheck = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("delegateCheck", para, success, error);
  };

  exportPendingTodoList = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("exportPendingTodoList", para, success, error);
  };

  exportCompletedTodoList = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("exportCompletedTodoList", para, success, error);
  };

  checkCompletedToDoListExport = (para: any) => {
    // @ts-ignore
    return this.sendSyncRequest("checkCompletedToDoListExport", para);
  };

  getDelegateToList = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getDelegateToList", para, success, error);
  };

  // @ts-ignore
  getMultipleDelegateToList = (
    payload: GetMultipleDelegateToListPayloadType
  ): Promise<GetMultipleDelegateToListResponseType> =>
    this.sendSyncRequest("getMultipleDelegateToList", payload);

  // @ts-ignore
  multipleDelegate = (
    payload: MultipleDelegatePayloadType
  ): Promise<MultipleDelegateResponseType> => this.sendSyncRequest("multipleDelegate", payload);
}

const toDoListService = new ToDoListService();

export default toDoListService;
